import { red, lightBlue, green } from 'web-ui-kit/colors';
import Space from 'redux/models/Space';

const TAT_COPY = 'The countdown to your designs is on!';

export const PROJECT_SUBMITTED_TAT_COPY = {
  title: TAT_COPY,
  description: `
    Please keep an eye on your inbox to confirm your photos are approved.
    If we need any extra info, we'll reach out asap to avoid any delays in your project.
  `
};

export const PROJECT_SUBMITTED_TAT_COPY_LUXE = {
  title: TAT_COPY,
  description: `
  Your Luxe designer will reach out to you in the next 24-48 hours
  with an invitation to schedule a kick-off call at your convenience.
  During this call, you and your Luxe designer will set a due date for your initial design delivery!`
};

export const PROJECT_SUBMITTED_DELAYED_TAT_COPY = {
  [Space.EtaStatus.ETA_DELAYED]: {
    title: 'Heads up - we\'re running a bit behind.',
    description: `
      We're experiencing delays in our delivery times, and sincerely
      apologize for the extra wait time! We promise you'll still receive
      the highest quality designs – just a few days late.
    `
  },
  [Space.EtaStatus.ETA_UNKNOWN]: {
    title: 'Heads up - we\'re running a bit behind.',
    description: `
      We aren't able to give a delivery estimate at this moment, and
      apologize for the extra wait time! We promise you'll still receive
      the highest quality designs – just a few days late.
    `
  },
  [Space.EtaStatus.ETA_VERY_DELAYED]: {
    title: 'Heads up - we\'re running behind.',
    description: `
      We're experiencing delays in our delivery times, and sincerely
      apologize for the extra wait time! We promise you'll still receive
      the highest quality designs – just a few days late.
    `
  }
};

export const PROJECT_SUBMITTED_WAITING_OPTIONS = [
  {
    title: 'Get Connected',
    description: `
Join our community on Instagram and find a daily dose of
design inspiration, weigh in on style polls, and get the best
in furniture puns, daily.
    `,
    buttonColor: red,
    buttonText: 'Go to our Instagram',
    linkUrl: 'https://www.instagram.com/modsydesign/?hl=en',
    src: 'https://s3-us-west-2.amazonaws.com/modsy/client/post-purchase-onboarding/dashboard/Bed.jpg'
  },
  {
    title: 'Get Inspired',
    description: `
Full of layout ideas, tips and tricks, and real customer
stories, check out our blog and be inspired by the
possibilities for your space.
    `,
    buttonColor: lightBlue,
    buttonText: 'Go to our Blog',
    linkUrl: 'https://blog.modsy.com',
    src: 'https://s3-us-west-2.amazonaws.com/modsy/client/post-purchase-onboarding/dashboard/Living.jpg'
  },
  {
    title: 'Get Cat Videos',
    description: `
Yes, you read that right.
    `,
    buttonColor: green,
    buttonText: 'Go to YouTube',
    linkUrl: 'https://www.youtube.com/watch?v=MiRAp-XSfTo',
    src: 'https://s3-us-west-2.amazonaws.com/modsy/client/post-purchase-onboarding/dashboard/Cat.jpg'
  }
];

// The project routes that required retail banner
export const RETAIL_BANNER_PROJECT_ROUTES = [
  '/project/room',
  '/project/style',
  '/project/budget',
  '/project/goal',
  '/project/furniture'
];
